// extracted by mini-css-extract-plugin
module.exports = {"root":"DispexInput_root__1-kdF"};